// extracted by mini-css-extract-plugin
export var fullHeightState = "_28-7";
export var headerCell = "_28-1";
export var loadingStateCell = "_28-4";
export var rowWrapper = "_28-3";
export var standaloneTable = "_28-8";
export var standaloneTableWithBodyFill = "_28-9";
export var stateCell = "_28-5";
export var table = "_28-0";
export var tableBodyFiller = "_28-6";
export var white = "_28-2";